import PropTypes from 'prop-types';

export default PropTypes.shape({
  title: PropTypes.string.isRequired,
  conditionalDescription: PropTypes.string.isRequired,
  theScience: PropTypes.string.isRequired,
  lowCharacteristics: PropTypes.arrayOf(PropTypes.string.isRequired),
  highCharacteristics: PropTypes.arrayOf(PropTypes.string.isRequired),
  phrases: PropTypes.exact({
    theScienceTitle: PropTypes.string.isRequired,
    lowCharacteristicTitle: PropTypes.string.isRequired,
    highCharacteristicTitle: PropTypes.string.isRequired,
  }).isRequired,
});
